<template>
  <teleport to=".menu">
    <div @click="show">Settings</div>
  </teleport>

  <teleport to="#settings">
    <div v-if="visible" class="modal" @click="close">
      <div class="panel">
        <header>Settings <span class="close" @click="toggle">x</span></header>
        <div class="setting-item-container">
          <div class="setting-item">
            <div class="field-label">Midi Input</div>
            <div class="field">
              <div class="midi-input-item" v-for="input of midiIns"
                   :key="input.name"
              ><label>{{ input.name }}<input type="checkbox"
                                             v-model="input.selected"
                                             name="'midi-in'"
                                             @change="updateMidiInSettings"></label>
              </div>
            </div>
          </div>
          <div class="setting-item">
            <div class="field-label">Input Scheme</div>
            <div class="field"></div>
          </div>
          <div class="setting-item">
            <div class="field-label">Other1</div>
            <div class="field"></div>
          </div>
          <div class="setting-item">
            <div class="field-label">Other2</div>
            <div class="field"></div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'SettingsPanel',
  data () {
    return {
      visible: true,
      midiIns: []
    }
  },
  created () {
    setTimeout(this.retrieveMidiInputs.bind(this), 200)
  },
  beforeUpdate () {
  },
  methods: {
    toggle () {
      this.visible ^= true
    },
    show () {
      this.visible = true
    },
    close (e) {
      if (!!document.querySelector('.panel') && !document.querySelector('.panel').contains(e.target)) {
        this.visible = false
        e.stopPropagation()
      }
    },
    retrieveMidiInputs () {
      const numberOfInputs = window.$MIDIAgent._WebMidi.inputs.length
      console.log('number of inputs', numberOfInputs)
      console.log('all selected inputs', window.$MIDIAgent.selectedInputs)
      this.midiIns.splice(0) // clear
      for (let i = 0; i < numberOfInputs; i++) {
        const input = window.$MIDIAgent._WebMidi.inputs[i]
        this.midiIns.push({
          name: input.name,
          id: input.id,
          selected: window.$MIDIAgent.selectedInputs.findIndex(x => x === input.name) > -1
        })
      }
    },
    updateMidiInSettings (e) {
      const selected = this.midiIns.filter(x => x.selected).map(x => x.name)
      console.log('selected', selected)
      window.$MIDIAgent.setInputs(selected)
      this.retrieveMidiInputs()
      // window.$MIDIAgent.initWebMidi()
    }
  }
}
</script>

<style scoped>

.modal {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #00000099;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.close {
  position: absolute;
  right: 0;
  top: 50%;
  height: 100%;
  width: 30px;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-50%);
  border-left: 2px solid #ccc;
}

.close:hover {
  background: #ccc;
  cursor: pointer;
}

.panel {
  position: absolute;
  height: 80vh;
  width: 70vw;
  background: #fff;
  text-align: center;
  border-radius: 2px;
}

header {
  /*padding: 5px;*/
}

.setting-item-container {
  padding: 5px;
  display: flex;
  flex-direction: column;
  place-content: start;
  text-align: left;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  margin: 10px;
}

.field-label {
  display: inline-block;
  width: 33%;
  color: #666;
  font-size: 90%;
}

.midi-input-item {
  text-align: right;
  margin-bottom: 10px;
}
</style>
